import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    loadingDocs: false,
    loadingPdfs: false,
    docs: {},
    pdfs: {}
  },
  mutations: {
    setLoadingDocs(state, payload) {
      state.loadingDocs = payload;
    },
    setLoadingPdfs(state, payload) {
      state.loadingPdfs = payload;
    },
    setDocs(state, payload) {
      state.docs = payload;
    },
    setPdfs(state, payload) {
      state.pdfs = payload;
    }
  },
  actions: {
    loadDocs({ commit }, payload) {
      commit('setLoadingDocs', true);
      commit('setDocs', {});

      axios
        .post(process.env.VUE_APP_API_DOC, payload)
        .then(response => {
          commit('setDocs', response.data);
          commit('setLoadingDocs', false);
        })
        .catch(() => {
          commit('setLoadingDocs', false);
        });
    },
    loadPdfs({ commit }, payload) {
      commit('setLoadingPdfs', true);
      commit('setPdfs', {});

      axios
        .post(process.env.VUE_APP_API_PDF, payload)
        .then(response => {
          commit('setPdfs', response.data);
          commit('setLoadingPdfs', false);
        })
        .catch(() => {
          commit('setLoadingPdfs', false);
        });
    }
  },
  getters: {
    loadingDocs(state) {
      return state.loadingDocs;
    },
    loadingPdfs(state) {
      return state.loadingPdfs;
    },
    docs(state) {
      return state.docs;
    },
    pdfs(state) {
      return state.pdfs;
    }
  }
});
